<template>
	<div class="container container--narrow pdt-30">

		<div class="t-headline11 font-m  mgb-16" v-if="previewData.type" >{{$t('611')}}</div>

		<div class="b-radius4 position-relative align-items-center justify-content-center mgb-24" v-if="previewData.type" >
			<component :is="previewData.type.value"
				:previewData="previewData"
				:orientationMode="orientationMode"
				:thumbNail="thumbNail"
				class="mgt-8"
			></component>
		</div>


		<div class="mdc-card mgb-24 pdb-8" v-if="summeryData" >
			<div class="pdt-24 pdl-24 pdr-24 ">
				<div class="t-headline7 font-m ">{{$t('612')}}</div>
			</div>
			<template  v-for="(summery, index) in summeryData"  >
				<div class="pdt-24 pdb-16 pdl-24 pdr-24"  :key="index" >
					<div class="t-body1 font-r pdb-8" v-if="summeryData.length>1" >{{summery.name}}</div>
					<div class="t-body1 font-r t-color-bodyGrayA">{{summery.purpose}}</div>
				</div>
				<div v-if="index < summeryData.length-1" class="divider" :key="'diveder'+index" ></div>
			</template>
		</div>

		<div class="mdc-card  mgb-24" v-if="reviewDataUser && reviewDataUser.length<1">
			<div class="mgb-24 d-flex justify-content-center mgt-24">
				<img src="/img/no-data-register-62.svg" alt="" class="icon62">
			</div>
			<div class="t-body1 t-color-bodyGrayA font-r t-center mgb-24">
				{{$t('3089')}} <!-- <br /> {{$t('3090')}-->
			</div>
			<div class="divider mgt-8"></div>
			<div class="pdt-12 pdr-24 pdb-12 pdl-24 " v-if="writePermission==true" >
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8 mdc-ripple-upgraded" @click="moveReviewPost()" @keypress="moveReviewPost()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('1927')}}</span>
				</button>

			</div>
		</div>

		<div class="mdc-card  mgb-24"  v-if="reviewDataUser && reviewDataUser.length>0" >
			<div class="pdt-24 pdl-24 pdr-24" >

				<div class="d-flex" v-if="reviewSummaryData.average" >
					<div class="t-headline7 font-m  mgb-8 mgr-12">{{reviewSummaryData.average.toFixed(2)}}</div>
					<div class="t-headline7 font-m  mgb-8 mgr-12 t-color-bodyGrayA"> {{$t('613')}}</div>
				</div>

				<ReviewListItem
						v-for="(review, index) in reviewDataUser" :key="index"
						:review="review"
			></ReviewListItem>


			</div>

			<div class="divider mgt-16"></div>
			<div class="pdt-12 pdb-12 pdl-24 pdr-24">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click="moveReviewPost()"  @keypress="moveReviewPost()" v-if="writePermission==true" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('1927')}}</span>
				</button>
				<button class="mdc-button bg-white t-color-secondaryBtnText mgr-8"  @click="moveReview1()" @keypress="moveReview1()" v-if="reviewDataUser.length>0" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('1928')}}</span>
				</button>
			</div>

		</div>


		<div class="mdc-card  mgb-24 pdb-8" v-if="skillsetData.length" >
			<div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('615')}}</div>
			<div class="d-flex pdt-16 mgl-24" v-for="(skillset, index) in skillsetData" :key="index" >
				<div class="list-image-small" skillset.standard.image >
					<img :src="skillset.standard.image" class="circle" alt="">
				</div>
				<div class="flex-grow-1 pdl-20">
					<div class="t-body1 mgb-16  font-r pdr-24">
					   {{skillset.standard.code}}
					   <div class="t-body3 mgt-3" v-if="skillset.standard.name">
								{{skillset.standard.name}}
						</div>
					</div>
					<div class="divider"></div>
				</div>
			</div>

		</div>

		<div class="mdc-card  mgb-24" v-if="teacher" >
			<div class="pdt-24 pdl-24 pdr-24 pdb-16">
				<div class="t-headline7 font-m  mgb-16 mgr-12">{{$t('616')}}</div>
				<div class="d-flex pdt-16 pdb-16">
					<UserImgProfile :data="teacher" :className="'mgr-0'" />
					<div class="flex-grow-1 pdl-20 mgb-4">
						<div class="t-body1 mgb-4 font-r t-line-h-24">
							{{ teacher.name?$t('3437',{first: teacher.name.first, last: teacher.name.last}):''}}
						</div>
						<div class="t-body3  t-color-bodyGrayA font-r mgr-8 t-line-h-19">{{ handleMaskingEmail(teacher.userId) }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mdc-card pdt-15 pdl-24 pdb-15 pdr-7 mgb-50" v-if="periodData" >
			<div class="d-flex align-items-center justify-content-between" @click="togglePeriod" @keypress="togglePeriod" tabindex="0">
				<div class="t-headline7 font-m flex-grow-1">{{$t('617')}}</div>
				<i class="material-icons mdc-icon-button toggler">{{periodShowState ? 'expand_less' : 'expand_more'}}</i>
			</div>

			<div class=" pdr-17 toggle-data mgt-4" v-show="periodShowState" >

				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r">{{$t('636')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r">{{displayPeriod(periodData.register)}}</div>
				</div>
				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r">{{$t('637')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r">{{displayPeriod(periodData.registerCancel)}}</div>
				</div>
				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r">{{$t('638')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r">{{displayPeriod(periodData.learning)}}</div>
				</div>
				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r">{{$t('639')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r">{{displayPeriod(periodData.review)}}</div>
				</div>
				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r">{{$t('640')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r">{{displayPeriod(periodData.midterm)}}</div>
				</div>
				<div class="pdt-18 pdb-18 align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA font-r"> {{$t('641')}}</div>
					<div class="t-body1 t-color-headlineBlack l-spacing48 t-line-h-22 font-r"> {{displayPeriod(periodData.scoreConfirm)}}</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
/**
 * 차수 상세 과정개요 탭 컴포넌트(degree view summary tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'
import ReviewListItem from '../review/ListItem.vue'
import {MDCRipple} from '@material/ripple'
import { userMixin } from '@/mixins/user'
import { utilDateMixin } from "@/mixins/dateUtil";

export default {
	props: ['teacher'],
	mixins: [ userMixin, utilDateMixin ],
	components: {
    'VIDEO': () => import('../preview/Video.vue'),
    'SLIDE': () => import('../preview/Slide.vue'),
    ReviewListItem,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
},

	data() {
		return {
			previewData: {type: null},
			periodData: null,
			summeryData: null,
			periodShowState: false,
			skillsetData: [],
			reviewData: [],
			reviewDataUser: [],
			reviewSummaryData: {},
			orientationMode : '',
			thumbNail: '',
			writePermission: false,
			bgColorOfName : localStorage.getItem('bgColors'),
		}
	},

	mounted() {

		this.fetchData()
		this.setMaterialUi()
	},
	methods: {

		// 과정정보 API 호출 및 데이터 설정(call api data)
		fetchData() {
		//	this.$showLoading()
			let responseData = null
			let params = this.setParams()

			degreeApi.guestLearnOnlineViewBasic(params).then((response) => {
				let getThumbNail = response.data.data
				this.thumbNail = getThumbNail.thumbnail
			}).catch((err) => {
			})

			// 미리보기(preview)
			degreeApi.guestLearnOnlineViewPreview(params).then((response) => {
				this.previewData = response.data.data
			}).catch((err) => {
			})

			// 기간정보(period)
			degreeApi.guestLearnOnlineViewPeriod(params).then((response) => {
				this.periodData = response.data.data
			}).catch((err) => {
			})

			// 학습목표(summery)
			degreeApi.guestLearnOnlineViewSummery(params).then((response) => {
				this.summeryData = response.data.data
			}).catch((err) => {
			})

			// 스킬셋(skillset)
			degreeApi.guestLearnOnlineViewSkillset(params).then((response) => {
				this.skillsetData = response.data.data
			}).catch((err) => {
			})

			// 과정 리뷰 목록(review list)
			degreeApi.guestLearnOnlineViewReview(params).then((response) => {
				this.reviewData = response.data.data.content
			}).catch((err) => {
			})

			//과정 리뷰 평점(review summary)
			degreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
				this.reviewSummaryData = response.data.data
			}).catch((err) => {
			})

			// 과정 리뷰 목록(review list)
			degreeApi.learnOnlineViewReview(params).then((response) => {
				this.reviewDataUser = response.data.data.content
			}).catch((err) => {
			})

			degreeApi.authPermission(params).then((reponse)=>{
				this.writePermission = reponse.data.data.registrationAuth
			}).catch((err) => {
			})

			//this.$hideLoading()
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				degreeId: this.$route.params.degreeId,
				language: JSON.parse(localStorage.getItem('languageInfo')).code,
				size: 3
			}
			return params
		},

		// 기간정보 노출 설정(set period show state)
		togglePeriod() {
			this.periodShowState = !this.periodShowState
		},


		// 리뷰 목록 이동(move to review)
		moveReview() {
			this.$router.push({
				name: 'DegreeReviewList',
				params: this.$route.params,
				query: this.$route.query,
			})
		},
		moveReview1() {
			this.$router.push('/review-list/'+this.$route.params.degreeId)
		},
		moveReviewPost() {
			this.$router.push('/review-post/'+this.$route.params.degreeId)
			// this.$router.push({
			//     name: 'DegreeReviewEdit',
			//     params: this.$route.params,
			//     query: this.$route.query,
			// })
		},

		getFirstLetter() {
			//console.log('fullName',this.teacher.name.fullName);
            let firstCharOfName = this.teacher.name.fullName.trim().slice(0,1);
			//console.log('firstCharOfName',firstCharOfName);
            //localStorage.setItem('firstChar', firstCharOfName)
            return firstCharOfName;
        },

        getRandomColor(){
            let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f','#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
            let randomColor = colors[Math.floor(Math.random() * colors.length)];
            //localStorage.setItem('bgColors', `background-color:${randomColor}`)
            return `background-color:${randomColor}`
        },

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

		},


	}
}
</script>

<style scoped>
 .mdc-elevation--z3 {
			border-radius: 4px;
			overflow: hidden;
			box-shadow: 0 1px 3px 0 var(--Shadow1);
			background-color: var(--DocumentWhite);
		}
.l-spacing78 {
			letter-spacing: -0.78;
		}

		.rating-wrapper.active {
			background:var(--DocumentGray);
			border-radius: 8px;
			padding-left: 16px;
			padding-right: 16px;
			padding-top: 16px;
		}

		.rating-wrapper.active #grade_toggler {
			display: block;
		}

		span.grade {
			color: var(--Iconinactive);
			font-size: 14px;
		}

		span.grade.selected {
			color: var(--Starmark);
		}

		#grade_toggler {
			color: var(--Iconinactive);
			cursor: pointer;
			display: none;
		}

		.toggle-menu {
  width: 112px;
  height: 112px;
  right: -2px;
  top: 24px;
  box-shadow: 0 10px 13px 0 var(--shadow2);
  border: solid 1px var(--Divider);
  transition: all 300ms ease-in-out;
}
html[dir="rtl"] .toggle-menu {
  left: -2px;
}

		.toggle-menu>div {
			cursor: pointer;
		}

		.toggleX300 {
			transform: translateX(300px);
		}

		.bg-mainBtn {
			background: var(--Mainbtn) !important;
		}
		.running-content{
			font-weight: 400;
			padding-right: 20px;
			line-height: 1.57;
		}
		html[dir="rtl"] .running-content{
			padding-left: 20px;
		}
		.divider.rightSide{
			margin-left:72px;
		}
		html[dir="rtl"] .divider.rightSide{
			margin-right:72px;
		}
</style>
